module.exports = __webpack_public_path__ + "img/safari_tips_fr.a367efbc.png";